// hooks/usePendo.ts
import { useEffect, useRef } from "react";


export default function usePendo({
  enabled,
  visitorId,
  accountId,
  parentId,
}) {
  const hasInit = useRef(false);

  useEffect(() => {
    if (!enabled || !visitorId || !accountId || !parentId) return;

    const pendo = (window).pendo;
    if (!pendo) return;

    const cfg = {
      visitor:       { id: visitorId },
      account:       { id: accountId },
      parentAccount: { id: parentId },
    };

    if (!hasInit.current) {
      pendo.initialize(cfg);
      hasInit.current = true;
    } else if (pendo.isReady()) {
      pendo.identify(cfg);
    }
  }, [enabled, visitorId, accountId, parentId]);
}
